
    import './styles.scoped.css';
    export default {
  "with-motion-vertical": "awsui_with-motion-vertical_b18tp_9rpg6_10",
  "with-motion-horizontal": "awsui_with-motion-horizontal_b18tp_9rpg6_29",
  "resize-active": "awsui_resize-active_b18tp_9rpg6_48",
  "resize-side": "awsui_resize-side_b18tp_9rpg6_59",
  "resize-bottom": "awsui_resize-bottom_b18tp_9rpg6_62"
};
  